(function () {
    'use strict';

    const animDuration = 350;

    const supports = Object.create(null);

    const state = Object.create(null);

    const media = Object.defineProperties(Object.create(null), {
        'desktop': { get: () => matchMedia('(min-width: 1025px)') },
        'tablet': { get: () => matchMedia('(min-width: 768px) and (max-width: 1024px)') },
        'mobile': { get: () => matchMedia('(max-width: 767px)') },
        'mobileOrTablet': { get: () => matchMedia('(max-width: 1024px)') },
        'tabletOrDesktop': { get: () => matchMedia('(min-width: 768px)') },
    });

    const utils = Object.defineProperties(Object.create(null), {

        'getRandomInt': { value: (min, max) => Math.floor(Math.random() * (max - min)) + min },

        'getRandom': { value: (min, max) => Math.random() * (max - min) + min },

        // Easing functions for use with animate(), source: http://gizma.com/easing/
        'easings': {
            value: {
                linear: function linear(t, b, c, d) {
                    return c * t / d + b;
                },
                easeInCubic: function easeInCubic(t, b, c, d) {
                    t /= d;
                    return c * t * t * t + b;
                },
                easeOutCubic: function easeOutCubic(t, b, c, d) {
                    t /= d;
                    t--;
                    return c * (t * t * t + 1) + b;
                },
                easeInOutCubic: function easeInOutCubic(t, b, c, d) {
                    t /= d / 2;
                    if (t < 1) {
                        return c / 2 * (t * t * t) + b;
                    }
                    t -= 2;
                    return c / 2 * (t * t * t + 2) + b;
                },
                easeInSine: function easeInSine(t, b, c, d) {
                    return -c * Math.cos(t / d * (Math.PI / 2)) + c + b;
                },
                easeOutSine: function easeOutSine(t, b, c, d) {
                    return c * Math.sin(t / d * (Math.PI / 2)) + b;
                },
                easeInOutSine: function easeInOutSine(t, b, c, d) {
                    return -c / 2 * (Math.cos(Math.PI * t / d) - 1) + b;
                }                
            }
        },

        // Computes values from 'from' to 'to' over time 'duration' using easing function 'easing', calling function 'update' with the current value on every frame, and calling 'compare' when finished.
        'animate': {
            value: (from, to, duration, easing, update, complete) => {
                const change = to - from;

                requestAnimationFrame(start => {
                    (function frame(now) {
                        const elapsed = now - start;

                        if (elapsed < duration) {
                            update(easing(elapsed, from, change, duration));
                            requestAnimationFrame(frame);
                        } else {
                            update(easing(duration, from, change, duration));
                            if (typeof complete === 'function') {
                                complete();
                            }
                        }
                    }(start));
                });                
            }
        },

        // Create and dispatch a synthetic event
        'dispatch': {
            value: (event, element, data) => {
                var evt = document.createEvent('Event');
                evt.initEvent(event, true, true);
                evt.data = data;
                element.dispatchEvent(evt);

            }
        },
    });

    (function bootstrap() {
        Object.defineProperty(supports, 'passiveeventlisteners', {
            get: (function () {
                let supported = false;
                try {
                    window.addEventListener('test', null, Object.defineProperty({}, 'passive', { 
                        get: () => supported = true 
                    }));
                } catch (ex) {}
                return () => supported;
            }())
        });

        Promise.all([
            Promise.race([
                new Promise(resolve => window.addEventListener('load', resolve)),

                new Promise(resolve => {
                    if (document.readyState === 'interactive' || document.readyState === 'complete') {
                        resolve();
                    } else {
                        document.addEventListener('DOMContentLoaded', resolve);
                    }
                }),
            ]),

            new Promise(resolve => WebFont.load({
                    classes: false,
                    custom: {
                        families: ['CNN Sans Display'],
                        urls: ['fonts/cnn-sans-display.css']
                    },
                    active: resolve
                })
            )
        ]).then(init);
    }());

    function init() {
        Object.defineProperties(state, {
            'sectionEls': { value: Array.from(document.querySelectorAll('#section-container > section')) },
            'mainEl': { value: document.querySelector('main') },
            'headerEl': { value: document.getElementById('sponsor-content-header') },
            'footerEl': { value: document.querySelector('body > footer:nth-of-type(1)') },
            'navMarkerEl': { value: document.getElementById('pitney-nav-marker') },
        });

        initAnimation();
        initVideo();
        initNav();
        initScroll();
    }

    function initAnimation() {
        const canvasEl = document.getElementById('animation');
        const context = canvasEl.getContext('2d');
        const animVidEl = document.getElementById('animation-video');

        animVidEl.play();

        (function animate() {
            if (animVidEl.paused || animVidEl.ended) {
                return;
            }

            context.clearRect(0, 0, canvasEl.width, canvasEl.height);
            context.drawImage(animVidEl, 0, 0, canvasEl.width, canvasEl.height, 0, 0, canvasEl.width, canvasEl.height);

            let rgba = context.getImageData(0, 0, canvasEl.width, canvasEl.height);

            context.clearRect(0, 0, canvasEl.width, canvasEl.height);
            context.drawImage(animVidEl, 0, canvasEl.height, canvasEl.width, canvasEl.height, 0, 0, canvasEl.width, canvasEl.height);

            let mask = context.getImageData(0, 0, canvasEl.width, canvasEl.height);

            for (let p = 0; p < rgba.data.length; p += 4) {
                rgba.data[p + 3] = mask.data[p];
            }

            context.putImageData(rgba, 0, 0);

            requestAnimationFrame(animate);
        }());
    }

    function initVideo() {
        let vimeoPlayer = null;

        document.getElementById('play-button').addEventListener('click', evt => {
            document.getElementById('vimeo-embed').classList.add('visible');

            vimeoPlayer = new Vimeo.Player('vimeo-embed-wrapper', {
                id: 217714032
            });

            vimeoPlayer.on('timeupdate', function timeupdate(t) {
                if (t.percent >= 0.25) {
                    ga('send', 'event', 'video', '25%');
                    vimeoPlayer.off('timeupdate', timeupdate);
                }
            });

            vimeoPlayer.on('timeupdate', function timeupdate(t) {
                if (t.percent >= 0.5) {
                    ga('send', 'event', 'video', '50%');
                    vimeoPlayer.off('timeupdate', timeupdate);
                }
            });

            vimeoPlayer.on('timeupdate', function timeupdate(t) {
                if (t.percent >= 0.75) {
                    ga('send', 'event', 'video', '75%');
                    vimeoPlayer.off('timeupdate', timeupdate);
                }
            });

            vimeoPlayer.on('play', () => ga('send', 'event', 'video', 'play'));

            vimeoPlayer.on('ended', () => ga('send', 'event', 'video', 'ended'));

            vimeoPlayer.ready().then(() => vimeoPlayer.play());
        });

        document.getElementById('vimeo-embed').addEventListener('click', evt => {
            if (vimeoPlayer) {
                vimeoPlayer.pause();
            }
            document.getElementById('vimeo-embed').classList.remove('visible');
        });        
    }

    function initNav() {
        function scrollToSection(section) {
            if (scrollToSection.busy) {
                return;
            }

            scrollToSection.busy = true;

            const from = document.documentElement.scrollTop || document.body.scrollTop;
            const to = from + section.getBoundingClientRect().top;
            const duration = animDuration * Math.abs(to - from) / window.innerHeight;

            utils.animate(
                from,
                to, 
                duration,
                utils.easings.easeInOutCubic,
                value => document.documentElement.scrollTop = document.body.scrollTop = value,
                () => delete scrollToSection.busy
            );
        }

        Array.from(document.querySelectorAll('#pitney-nav-rings > circle')).forEach((ring, index) => ring.addEventListener('click', () => {
            // console.log(`ga('send', 'event', 'nav', ${index+1})`);
            ga('send', 'event', 'nav', (index+1));
            scrollToSection(state.sectionEls[index]);
        }));
        Array.from(document.querySelectorAll('#pitney-nav-labels > text')).forEach((label, index) => label.addEventListener('click', () => {
            // console.log(`ga('send', 'event', 'nav', ${index+1})`);
            ga('send', 'event', 'nav', (index+1));
            scrollToSection(state.sectionEls[index]);
        }));        
    }

    function initScroll() {
        state.sectionEls.forEach(section => section.vid = section.querySelector('video.bg'));

        window.addEventListener('scroll', evt => {
            if (state.headerEl.getBoundingClientRect().bottom > 0) {
                document.body.classList.add('header-visible');
            } else {
                document.body.classList.remove('header-visible');
            }

            if (state.footerEl.getBoundingClientRect().top < window.innerHeight) {
                document.body.classList.add('footer-visible');
            } else {
                document.body.classList.remove('footer-visible');
            }

            state.sectionEls.forEach((section, num) => {
                const r = section.getBoundingClientRect();

                if (r.top >= window.innerHeight && r.top < window.innerHeight * 1.5) {
                    section.classList.add('approaching');
                } else {
                    section.classList.remove('approaching');
                }

                if (r.top < window.innerHeight) {
                    section.classList.add('attach');
                } else {
                    section.classList.remove('attach');
                }

                if (r.bottom < window.innerHeight) {
                    section.classList.add('detach');
                    if (section.vid && !(section.vid.paused)) {
                        section.vid.pause();
                    }
                } else {
                    section.classList.remove('detach');
                }

                if (r.top <= window.innerHeight * 1.1 && r.bottom >= window.innerHeight) {
                    if (section.vid && section.vid.paused) {
                        section.vid.play();
                    }
                }

                if (r.top < window.innerHeight && (r.bottom > window.innerHeight || num === state.sectionEls.length - 1)) {
                    state.navMarkerEl.classList.add(`section-${num + 1}`);
                } else {
                    state.navMarkerEl.classList.remove(`section-${num + 1}`);
                }
            });
        }, supports.passiveeventlisteners ? { passive: true } : false);

        let untriggered = state.sectionEls.slice();

        window.addEventListener('scroll', function trigger() {
            untriggered.forEach(section => {
                const r = section.getBoundingClientRect();
                const frac = window.innerHeight / 2;

                if (!(r.top <= frac && r.bottom >= window.innerHeight) && !(r.bottom >= frac && r.top <= 0)) {
                    return;
                }

                let index = state.sectionEls.indexOf(section);

                // console.log(`ga('send', 'event', 'depth', ${index+1})`);
                ga('send', 'event', 'depth', (index+1));

                section.classList.add('triggered');

                untriggered = untriggered.filter(section => !(section.classList.contains('triggered')));

                if (untriggered.length === 0) {
                    untriggered = null;
                    window.removeEventListener('scroll', trigger);
                }
            });
        }, supports.passiveeventlisteners ? { passive: true } : false);        

        utils.dispatch('scroll', window);
    }

}());
